import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Colors } from '@gripp/shared-ui';
import { StyleSheet, Text, View } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { AssetRoutinesForm } from './assetRoutinesForm';

type AddonsButtonProps = {
  addonsCount: number;
  assetId: string;
  name: string;
};

export const AddonsButton = ({
  addonsCount,
  assetId,
  name,
}: AddonsButtonProps) => {
  const getLabel = (labelStyle: any, label: string) => {
    return <Text style={[labelStyle, styles.cellText]}>{label}</Text>;
  };

  return (
    <ModalButton
      label=""
      customButton={
        <View style={[styles.iconContainer]}>
          <MaterialCommunityIcons
            name="shape-outline"
            color={Colors.primary}
            size={16}
            style={styles.icon}
          />
          {getLabel(styles.countText, (addonsCount ?? 0).toString())}
        </View>
      }
      modalComponent={({ onComplete }: { onComplete: () => void }) => (
        <AssetRoutinesForm
          assetId={assetId}
          title={name}
          onComplete={onComplete}
          initialTab="addons"
        />
      )}
      containerStyle={styles.modalContainer}
    />
  );
};

const styles = StyleSheet.create({
  iconContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  icon: {
    marginRight: 2,
  },
  countText: {
    fontSize: 16,
  },
  cellText: {
    fontSize: 16,
    fontWeight: '500',
    flexWrap: 'nowrap',
  },
  modalContainer: {
    width: 640,
    height: '80%',
    minHeight: 450,
    alignSelf: 'center',
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
  },
});
